import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { LangProvider } from "@/lib/i18n";
import { usePhotos } from "@/lib/usePhotos";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Themes } from "@/components/site/Themes";
import { Services } from "@/components/site/Services";
import { Corporate, About, Footer } from "@/components/site/Sections";
import { Inquiry } from "@/components/site/Inquiry";
import { Marquee } from "@/components/site/Marquee";
import { SmoothScroll, scrollToId } from "@/components/site/SmoothScroll";
import GalleryPage from "@/pages/GalleryPage";

const DEFAULT_POSTER = "images/weddings/weddings-26.jpg";

const Home = () => {
  const data = usePhotos();
  const { hash } = useLocation();
  const ready = !data.loading;

  useEffect(() => {
    if (!hash || !ready) return undefined;
    const id = hash.slice(1);
    const timer = setTimeout(() => scrollToId(id), 80);
    return () => clearTimeout(timer);
  }, [hash, ready]);

  const poster = data.themes.find((t) => t.id === "weddings")?.cover?.file || DEFAULT_POSTER;
  return (
    <main id="top">
      <Hero posterFile={poster} />
      <Themes themes={data.themes} />
      <About />
      <Services themes={data.themes} />
      <Corporate />
      <Marquee />
      <Inquiry />
    </main>
  );
};

const ScrollTopOnPage = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true, force: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

export default function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <SmoothScroll />
        <ScrollTopOnPage />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
      </LangProvider>
    </BrowserRouter>
  );
}
